export const finovoData = {
    designs: {
        title: 'High-fidelity designs',
        images: {
            mobile: [
                'finovo_mobile_1.png',
                'finovo_mobile_2.png',
                'finovo_mobile_3.png',
                'finovo_mobile_4.png',
                'finovo_mobile_5.png',
                'finovo_mobile_6.png',
                'finovo_mobile_7.png',
                'finovo_mobile_8.png',
                'finovo_mobile_9.png'
            ]
        }
    }
}
